import SignInVue from "@/modules/Auth/SignIn.vue";

const router = [
  {
    path: "/",
    name: "home",
    redirect: '/sign-in',
    component: SignInVue,
    meta: {
      layout: "AppAuthLayout",
      parent: "login",
      name: "login",
    },
  },
  {
    path: "/sign-in",
    name: "sign-in",
    component: SignInVue,
    meta: {
      layout: "AppAuthLayout",
      parent: "login",
      name: "login",
    },
  },
];

export default router;
